import styled from "styled-components"
import Button from "../shared/button/Btn"
import InputText from "../shared/input/new/InputText"
import InputNewAracTypeSelect from "../shared/input/new/InputNewAracTypeSelect"
import InputCaseTypeSelect from "../shared/input/new/InputCaseTypeSelect"
import InputNumberNew from "../shared/input/new/InputNumberNew"
import { profilOzVarlikAracEkle, profilOzVarlikAracGuncelleme, profilOzVarlikAracSilme } from "../../features/companyProfile/companyProfileSlice"
import { useDispatch } from "react-redux"
import {useState} from "react"
import { showModal } from "../../features/modal/modalSlice"
import moment from "moment"
import InputDate from  "../shared/input/new/InputDate"
import { AdminAracEkleOptions } from "../../utils/adminAracEkleOptions"
import dateConverter from "../../helper/dateConverter"
import useWindowDimensions from "../../hooks/useWindowSize"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 600px;
    overflow: auto;
    .content{
        padding: 20px 0;
        width: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        .row{
            width: 60%;
            p{
                font-size: 12px;
                color: var(--color-main);
                margin-top: 5px;
            }
        }
    } 

    .button-grp{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: auto;
        margin: 10px 0;
        gap: 50px;
    }

    @media (max-width: 750px){
        .row{
            width: 100% !important;
        }

        .button-grp{
            gap: 20px;
        }
    }
`
const ProfileAracDetails = ({aracItem}) => {
    const dispatch = useDispatch()

    const [data, setData] = useState({...aracItem, trafikSigortasıGecerlilikTarihi: dateConverter(aracItem?.trafikSigortasıGecerlilikTarihi, "us"), muayeneGecerlilikTarihi: dateConverter(aracItem?.muayeneGecerlilikTarihi, "us"), kaskoGecerlilikTarihi: dateConverter(aracItem?.kaskoGecerlilikTarihi, "us") })
    
    const [aracType, setAracType] = useState(aracItem?.truckType)
    const [kasaType ,setKasaType] = useState(aracItem?.trailerType)
    const [initialCaseType, setInitialCaseType] = useState(null)
    const {windowDimensions} = useWindowDimensions()

    const [isSubmitted, setIsSubmitted] = useState(false)

    const handleChange = (e) => {
        setData((prev) => ({...prev, [e?.target?.name]: e?.target?.value}))
    }

    const handleSubmit = () => {
        setIsSubmitted(true)
        const addData = {
            //! zorunlu alanlar
            id: data?.id,
            phoneNumber: data?.phoneNumber,
            truckType: aracType?.name || data?.truckType ,
            truckPlateNumber: data?.truckPlateNumber,
            
            //! opsiyonel alanlar
            //! kasa ve zemin
            trailerTypeId: kasaType?.id || data?.trailerTypeId,

            //! araç detay
            truckBrand: data?.truckBrand,
            truckModel: data?.truckModel,
            truckModelYear: parseInt(data?.truckModelYear) || 0,
            colorVehicle: data?.colorVehicle,

            //! tarihler
            trafikSigortasıGecerlilikTarihi: moment(data?.trafikSigortasıGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY"),
            muayeneGecerlilikTarihi: moment(data?.muayeneGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY"),
            kaskoGecerlilikTarihi: moment(data?.kaskoGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY")
        }
        dispatch(profilOzVarlikAracGuncelleme(addData))
    }

  return (
    <Container>
        <div className="content">
            <div className="row">
                <InputText data={data?.truckPlateNumber} setData={handleChange} labelText={"Plaka*"} name={"truckPlateNumber"} inputWidth={"100%"} />
                {
                    isSubmitted && !data?.truckPlateNumber &&
                    <p>Zorunlu Alan</p>
                }
            </div>

            <div className="row">
                <InputNewAracTypeSelect initialOptions={AdminAracEkleOptions} setInitialCaseType={setInitialCaseType} data={aracType} setData={setAracType} inputWidth={"100%"} labelText="Araç Türü*" name={"aracType"} />
                {
                    isSubmitted && !aracType &&
                    <p>Zorunlu Alan</p>
                }
            </div>
            
            {
                aracType?.name !== "Çekici" &&
                <div className="row">
                    <InputCaseTypeSelect  initialOptions={initialCaseType} data={kasaType} setData={setKasaType} inputWidth={"100%"} labelText="Kasa Tipi*" name={"selectCaseType"} />
                    {
                        isSubmitted && !kasaType &&
                        <p>Zorunlu Alan</p>
                    }
                </div>
            }

            <InputText data={data?.truckBrand} setData={handleChange} labelText={"Marka"} name={"truckBrand"} inputWidth={windowDimensions.width > 750 ? "60%" : "100%"} />
            <InputText data={data?.truckModel} setData={handleChange} labelText={"Model"} name={"truckModel"} inputWidth={windowDimensions.width > 750 ? "60%" : "100%"} />

            <InputNumberNew data={data?.truckModelYear} setData={handleChange} labelText={"Model Yılı"} name={"truckModelYear"} inputWidth={windowDimensions.width > 750 ? "60%" : "100%"} />
            <InputText data={data?.renk} setData={handleChange} labelText={"Rengi"} name={"renk"} inputWidth={windowDimensions.width > 750 ? "60%" : "100%"} />

            <InputDate data={data?.muayeneGecerlilikTarihi} setData={handleChange} labelText={"Muayene Geçerlilik Tarihi"} name={"muayeneGecerlilikTarihi"} inputWidth={windowDimensions.width > 750 ? "60%" : "100%"} />
            <InputDate data={data?.trafikSigortasıGecerlilikTarihi} setData={handleChange} labelText={"Trafik Sigortası Geçerlilik Tarihi"} name={"trafikSigortasıGecerlilikTarihi"} inputWidth={windowDimensions.width > 750 ? "60%" : "100%"} />
            <InputDate data={data?.kaskoGecerlilikTarihi} setData={handleChange} labelText={"Kasko Sigortası Geçerlilik Tarihi"} name={"kaskoGecerlilikTarihi"} inputWidth={windowDimensions.width > 750 ? "60%" : "100%"} />
        </div>

        <div className="button-grp">
            <Button bgColor={"transparent"} color={"#E85446"} width={windowDimensions.width > 750 ? "200px" : "160px"} handleClick={handleSubmit}>Güncelle</Button>
            <Button bgColor={"#E85446"} color={"#fff"} width={windowDimensions.width > 750 ? "200px" : "160px"} handleClick={() => {dispatch(showModal(null));dispatch(profilOzVarlikAracSilme(data.truckPlateNumber))}}>Aracı Sil</Button>
            <Button bgColor={"#E85446"} color={"#fff"} width={windowDimensions.width > 750 ? "200px" : "160px"} handleClick={() => dispatch(showModal(null))}>Kapat</Button>
        </div>
    </Container>
  )
}

export default ProfileAracDetails